module.exports = __webpack_public_path__ + "static/media/6ece0a3b.jpg";